import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from '../ResourceCard.module.scss';
import t from '@/utils/Language/ResourceCard-translations';

export const ServiceUtilization = ({ count }) => {
  if (!count) return null;
  return (
    <div className="d-flex align-items-center gap-2">
      <FontAwesomeIcon icon="fa-solid fa-users" />
      <div className={classes.membersUtilizationText}>
        <strong>{count}</strong> {t('members')} {t('used this service')}
      </div>
    </div>
  );
};
